import {
    CorrectAnswer,
    EntirePoll,
    MultiChoice,
    QuestionExt,
    Questions,
    ScriptQuestSets,
    Subquestion
} from "../../models";

export class AuthorPollUtil {

    /**
     *  Enrich Question with answers, subquestions and multiChoices from EntirePoll to make QuestionExt array
     * @param entirePoll
     * @returns {Questions}
     */
    public static getQuestionsExt(entirePoll: EntirePoll): Questions {

        const questions = new Questions();

        if (entirePoll) {
            const otherMaps = this.getQuestionsAllMaps(entirePoll);

            entirePoll.questions.forEach(question => {
                const questionExt = Object.assign(new QuestionExt(), question,
                    {
                        answers: otherMaps.answersMap[question.questNum],
                        subquestions: otherMaps.subquestionsMap[question.questNum],
                        multiChoices: otherMaps.multiChoicesMap[question.questNum]
                    });
                questions.push(questionExt);
            });
        }

        return questions;
    }

    public static hasGuestGroup(groups, guestGroupId): boolean {
        if (groups) {
            const guestGroup = groups.find((group: any) => group.groupId == guestGroupId);
            return guestGroup != null;
        }
        return false;
    }

    public static hasNonGuestGroup(groups, guestGroupId): boolean {
        if (groups) {
            const nonGuestGroup = groups.find((group: any) => group.groupId != guestGroupId);
            return nonGuestGroup != null;
        }
        return false;
    }


    /**
     *
     * @param {Questions} questions
     * @param {ScriptQuestSets} allScriptQuestSets
     * @param {number} scriptId
     * @returns Questions
     */
    public static getScriptQuestionsExt(questions: Questions, allScriptQuestSets: ScriptQuestSets, scriptId: number): { [questSetNum: number]: Questions } {

        // make pageNumQuestionsMap<page num><questions>
        const pageNumQuestionsMap: { [questSetNum: number]: Questions } = {};

        const questionsMap: { [questNum: number]: QuestionExt } = {};
        questions.forEach(question => questionsMap[question.questNum] = question);

        const scriptQuestSets = allScriptQuestSets.filter(scriptQuestSet => scriptQuestSet.scriptId === scriptId);
        scriptQuestSets.forEach(scriptQuestSet => {
            const qNums = scriptQuestSet.questSetDesc ? scriptQuestSet.questSetDesc.split(',') : [];

            const questionsExt: Questions = new Questions();
            qNums.forEach(qNum => {
                const question = questionsMap[qNum];
                questionsExt.push(question);
            });
            pageNumQuestionsMap[scriptQuestSet.questSetNum] = questionsExt;
        });

        return pageNumQuestionsMap;
    }

    private static getQuestionsAllMaps(entirePoll: EntirePoll): any {

        const answersMap: { [questNum: number]: Array<CorrectAnswer> } = {};
        const subquestionsMap: { [questNum: number]: Array<Subquestion> } = {};
        const multiChoicesMap: { [questNum: number]: Array<MultiChoice> } = {};

        if (entirePoll) {
            (entirePoll.correctAnswers || []).forEach(correctAnswer => {
                let answers: Array<CorrectAnswer> = answersMap[correctAnswer.questNum];
                if (!answers) {
                    answers = new Array();
                    answersMap[correctAnswer.questNum] = answers;
                }
                return answers.push(correctAnswer);
            });

            (entirePoll.subquestions || []).forEach(subquestion => {
                let subquestions: Array<Subquestion> = subquestionsMap[subquestion.questNum];
                if (!subquestions) {
                    subquestions = new Array();
                    subquestionsMap[subquestion.questNum] = subquestions;
                }
                return subquestions.push(subquestion);
            });

            (entirePoll.multiChoices || []).forEach(multiChoice => {
                let multiChoices: Array<MultiChoice> = multiChoicesMap[multiChoice.questNum];
                if (!multiChoices) {
                    multiChoices = new Array();
                    multiChoicesMap[multiChoice.questNum] = multiChoices;
                }
                return multiChoices.push(multiChoice);
            });
        }

        return {answersMap: answersMap, subquestionsMap: subquestionsMap, multiChoicesMap: multiChoicesMap};
    }

}
